import { render, staticRenderFns } from "./ExpertViewone.vue?vue&type=template&id=f2804e82&scoped=true"
import script from "./ExpertViewone.vue?vue&type=script&lang=js"
export * from "./ExpertViewone.vue?vue&type=script&lang=js"
import style0 from "./ExpertViewone.vue?vue&type=style&index=0&id=f2804e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2804e82",
  null
  
)

export default component.exports